<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('settings/settings:emergency-center.emergency-centers') }}
        </h2>

        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          :addBtnText="$t('buttons:add-specific', {specific: $t('settings/settings:emergency-center.emergency-center') })"
          icon="edit"
          @updateTableData="updateTable"
          @clickedButton1="editEmergencyCenter"
          @clickedAddButton="editEmergencyCenter"
          :addBtn="true"
          sortBy="name"
        />

      </v-col>
    </v-row>

    <EmergencyCenterForm
      @updateTable="updateAfterSave"
      :countries="countries"
      ref="emergencyCenterForm" />

  </div>
</template>
<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import EmergencyCenterForm from '@/modules/settings/views/settings/emergency-center/EmergencyCenterForm';
import EmergencyCenterService from '@/modules/settings/services/emergency-center-service';
import EmergencyCenter from '@/modules/settings/data/emergency-center';
import InfoService from '@/modules/core/services/info-service';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';


export default {
  name: "EmergencyTable",
  components: {
    EmergencyCenterForm,
    DataTablePaginated
  },
  data() {
    return {
      emergencyCenter: new EmergencyCenter(),
      countries: [],
      translatedCountries: new Map()

    };
  },
  computed: {
    headers() {
      return [
        {text: this.$t('common:id'), value: 'id'},
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('common:street'), value: 'street'},
        {text: this.$t('common:city'), value: 'city'},
        {text: this.$t('common:zip'), value: 'zip'},
        {text: this.$t('common:country'), value: 'translatedCountry'},
        {text: "", value: "controls", sortable: false}
      ]
    }
  },
  methods: {
    updateTable(options, search) {
      if (!search) search = '';

      EmergencyCenterService.readAllEmergencyCentersPaginated(
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        (response) => {
          response.data.content = DataUtils.parseDataToObjectArray(response.data.content, EmergencyCenter);

          response.data.content.forEach(
            (item) => {
              item.translatedCountry = this.translatedCountries.get(item.country)
            }
          )

          this.$refs.table.fillTableData(response.data);
        },
        () => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:emergency-center.emergency-center')}));
        }
      );
    },
    editEmergencyCenter(emergencyCenter) {
      this.$refs.emergencyCenterForm.initialization(emergencyCenter);
    },
    updateAfterSave() {
      this.$refs.table.callTableUpdate();
    }
  },
  created() {
    InfoService.readOptionsByUrl(
      'country',
      (response) => {
        this.countries = Utils.translateAllCountries(response);
        for (let i = 0; i < this.countries.length; i++) {
          this.translatedCountries.set(this.countries[i]['id'], this.countries[i]['translatedName']);
        }
      },
      () => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:emergency-center.emergency-center')}));
      }
    )
  }

}
</script>